// extracted by mini-css-extract-plugin
export default {"wrapper":"AQ-z","ratingContainer":"BQ-z","ratingValue":"CQ-z","starSprite":"DQ-z","ratingLabel":"EQ-z","error":"FQ-z","errorBox":"GQ-z"};